export default "__VITE_PUBLIC_ASSET__007df690__"